import React, { useContext, useMemo, useState } from 'react';
import type { SeekerMatchResult } from 'match';

type MatchContextValue = {
    matchResult: SeekerMatchResult | null;
    setMatchResult: React.Dispatch<React.SetStateAction<SeekerMatchResult | null>>;
};

const MatchContext = React.createContext<MatchContextValue | undefined>(undefined);

type MatchProviderProps = {
    initialValue?: SeekerMatchResult | null;
    children: React.ReactNode;
};

export function MatchProvider({ initialValue = null, children }: MatchProviderProps) {
    const [matchResult, setMatchResult] = useState<SeekerMatchResult | null>(initialValue);

    const value = useMemo(
        () => ({
            matchResult,
            setMatchResult
        }),
        [matchResult]
    );

    return <MatchContext.Provider value={value}>{children}</MatchContext.Provider>;
}

export function useMatch() {
    const context = useContext(MatchContext);
    if (!context) {
        throw new Error('useMatch must be used within a MatchProvider');
    }
    return context;
}


